import { useState } from "react";
import { Plus, Minus } from "lucide-react";

// Visible, crawlable FAQ accordion. Pair with faqSchema() in the page's Seo jsonLd.
// dark=true renders on the #1A1A18 dark sections; default is the light theme.
export function FaqSection({ faqs, dark = false, title = "Frequently asked questions", testid = "faq-section" }) {
  const [open, setOpen] = useState(0);
  if (!faqs?.length) return null;

  const border = dark ? "border-white/15" : "border-[#1A1A18]/10";
  const heading = dark ? "text-white" : "text-[#1A1A18]";
  const answer = dark ? "text-white/75" : "text-[#4F4C44]";
  const bg = dark ? "bg-white/[0.03]" : "bg-white";

  return (
    <section className={`py-16 ${dark ? "" : "bg-[#F9F8F6]"}`} data-testid={testid}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <p className="text-xs font-semibold tracking-widest uppercase text-[#C84B31] mb-3">FAQ</p>
        <h2 className={`font-heading font-bold text-2xl sm:text-3xl mb-8 ${heading}`}>{title}</h2>
        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className={`rounded-xl border ${border} ${bg} overflow-hidden`}>
                <button
                  type="button"
                  data-testid={`${testid}-q-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 py-4"
                >
                  <h3 className={`font-semibold text-base ${heading}`}>{f.q}</h3>
                  <span className="shrink-0 text-[#C84B31]">
                    {isOpen ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
                  </span>
                </button>
                {isOpen && (
                  <p className={`px-5 pb-5 -mt-1 text-sm leading-relaxed ${answer}`} data-testid={`${testid}-a-${i}`}>
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
